import { ProfileScreen } from '@/components/profile/profile-screen';

export default function ClientProfilePage() {
  return <ProfileScreen />;
}
